import { render } from "./Approach.vue?vue&type=template&id=d3e265d2&scoped=true"
import script from "./Approach.vue?vue&type=script&lang=js"
export * from "./Approach.vue?vue&type=script&lang=js"

import "./Approach.vue?vue&type=style&index=0&id=d3e265d2&scoped=true&lang=css"
import "./Approach.vue?vue&type=style&index=1&id=d3e265d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3e265d2"]])

export default __exports__